module.exports = __webpack_public_path__ + "img/banner_mobile_CN.a6a63b19.png";